/* SANTO collection: colour dots into drawer toolbar + sync count; survives facets AJAX re-render */
(function(){
  function place(){
    var tpl=document.querySelector('template[data-santo-dots]');
    var bar=document.querySelector('#main-collection-filters .facets-container-drawer');
    if(tpl&&bar&&!bar.querySelector('.santo-coll__dots')){
      var node=tpl.content.firstElementChild;
      if(node)bar.appendChild(node.cloneNode(true));
    }
    var pc=document.getElementById('ProductCount'),hc=document.querySelector('[data-santo-count]');
    if(pc&&hc){var t=pc.textContent.trim();if(t&&hc.textContent!==t)hc.textContent=t;}
  }
  function init(){
    place();
    var root=document.getElementById('main-collection-filters');
    if(root&&window.MutationObserver){new MutationObserver(place).observe(root,{childList:true,subtree:true,characterData:true});}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
